import React, {useState, useEffect} from 'react';
import OffersService from '../Services/OffersService';
import {Button, Table, Form, Col, Row, FormGroup, Input, Label, CardHeader, Modal, ModalBody} from 'reactstrap';
import { Card, CardBody } from 'reactstrap';
import {withTranslation} from "react-multi-lang";
import AuthService from "../Services/AuthService";

const OfferPackages = ({t}) => {
    const [offerPackages, setOfferPackages] = useState([]);
    const [offerPackage, setOfferPackage] = useState({});
    const [packageModal, setPackageModal] = useState(false);
    
    const togglePackageModal = () => setPackageModal(!packageModal);
    
    const authService = new AuthService();
    
    const offersService = new OffersService();
    
    useEffect(() => {
        offersService.getPackages().then(r => {
            setOfferPackages(r);
        });
    }, []);

    const saveOfferPackage = (e) => {
        e.preventDefault();
        offersService.savePackage(offerPackage).then(() => {
            togglePackageModal();
            offersService.getPackages().then(r => {
                setOfferPackages(r);
            });
        });
    };
    
    const getAssessments = () => {
        let config = authService.getConfig();
        let assessments = [];
        assessments = config.products.reduce((acc, p) => {
            acc.push(...p.assessments);
            return acc;
        }, []);
        return assessments;
    }
    
    const getTotalQty = (op) => {
        return op.assessment1Qty + (op.assessment2Qty ?? 0) + (op.assessment3Qty ?? 0) + 
            (op.assessment4Qty ?? 0) + (op.assessment5Qty ?? 0);
    };
    

    return <>
            <Card>
                <CardHeader>
                    <h4>Πακέτα Προσφορών</h4>
                </CardHeader>
                <CardBody>
                    <Row>
                        <Col md={6}>
                            
                        </Col>
                        <Col md={6} className="d-grid">
                            <Button color="primary" size="sm" onClick={togglePackageModal}>Νέο πακέτο προσφορών</Button>
                        </Col>
                    </Row>
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Όνομα</th>
                            <th>Συνολική Ποσότητα</th>
                            <th>Έκπτωση</th>
                            <th>Ενέργειες</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            offerPackages.map((op, index) => {
                                return <tr>
                                    <td>{op.name}</td>
                                    <td>{getTotalQty(op)} τόνοι</td>
                                    <td>{op.discount}%</td>
                                    <td><Button color={'primary'} size={'sm'}
                                        onClick={() => {
                                            setOfferPackage(op);
                                            togglePackageModal();
                                        }}>Επεξεργασία</Button></td>
                                </tr>
                            })
                        }
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
            <Modal isOpen={packageModal} toggle={togglePackageModal} size="lg">
                <ModalBody>
                    <Form onSubmit={saveOfferPackage}>
                        <FormGroup>
                            <Label>Όνομα Πακέτου</Label>
                            <Input type="text" value={offerPackage.name} 
                                   onChange={e => 
                                       setOfferPackage({...offerPackage, name: e.target.value})}/>
                        </FormGroup>
                        <FormGroup>
                            <Label>Έκπτωση Πακέτου %</Label>
                            <Input type="number" value={offerPackage.discount} placeholder='π.χ. 10 για 10% έκπτωση'
                                   onChange={e => 
                                       setOfferPackage({...offerPackage, discount: e.target.valueAsNumber})}/>
                        </FormGroup>
                        <Row>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Αξιολόγηση</Label>
                                    <Input type={"select"} value={offerPackage.assessment1} 
                                           onChange={e => 
                                               setOfferPackage({...offerPackage, assessment1: e.target.value})}>
                                        <option value="">Επιλέξτε Αξιολόγηση</option>
                                        {
                                            getAssessments().map(a => <option key={a} value={a}>{a}</option>)
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Ποσότητα (τόνοι)</Label>
                                    <Input type="number" value={offerPackage.assessment1Qty} 
                                           onChange={e => setOfferPackage({...offerPackage, assessment1Qty: e.target.valueAsNumber})}/>
                                </FormGroup>
                            </Col>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Ελάχιστη Παλαιότητα (μήνες)</Label>
                                    <Input type="number" value={offerPackage.assessment1minAge}
                                           onChange={e => setOfferPackage({...offerPackage, assessment1minAge: e.target.valueAsNumber})}/>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Αξιολόγηση</Label>
                                    <Input type={"select"} value={offerPackage.assessment2}
                                           onChange={e =>
                                               setOfferPackage({...offerPackage, assessment2: e.target.value})}>
                                        <option value="">Επιλέξτε Αξιολόγηση</option>
                                        {
                                            getAssessments().map(a => <option key={a} value={a}>{a}</option>)
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Ποσότητα (τόνοι)</Label>
                                    <Input type={"number"} value={offerPackage.assessment2Qty}
                                        onChange={e => setOfferPackage({...offerPackage, assessment2Qty: e.target.valueAsNumber})}/>
                                </FormGroup>
                            </Col>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Ελάχιστη Παλαιότητα (μήνες)</Label>
                                    <Input type="number" value={offerPackage.assessment2minAge}
                                           onChange={e => setOfferPackage({...offerPackage, assessment2minAge: e.target.valueAsNumber})}/>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Αξιολόγηση</Label>
                                    <Input type={"select"} value={offerPackage.assessment3}
                                           onChange={e =>
                                               setOfferPackage({...offerPackage, assessment3: e.target.value})}>
                                        <option value="">Επιλέξτε Αξιολόγηση</option>
                                        {
                                            getAssessments().map(a => <option key={a} value={a}>{a}</option>)
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Ποσότητα (τόνοι)</Label>
                                    <Input type={"number"} value={offerPackage.assessment3Qty}
                                    onChange={(e) => setOfferPackage({...offerPackage, assessment3Qty: e.target.valueAsNumber})}/>
                                </FormGroup>
                            </Col>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Ελάχιστη Παλαιότητα (μήνες)</Label>
                                    <Input type="number" value={offerPackage.assessment3minAge}
                                           onChange={e => setOfferPackage({...offerPackage, assessment3minAge: e.target.valueAsNumber})}/>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Αξιολόγηση</Label>
                                    <Input type={"select"} value={offerPackage.assessment4}
                                           onChange={e =>
                                               setOfferPackage({...offerPackage, assessment4: e.target.value})}>
                                        <option value="">Επιλέξτε Αξιολόγηση</option>
                                        {
                                            getAssessments().map(a => <option key={a} value={a}>{a}</option>)
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Ποσότητα (τόνοι)</Label>
                                    <Input type={"number"} value={offerPackage.assessment4Qty}
                                    onChange={(e) => setOfferPackage({...offerPackage, assessment4Qty: e.target.valueAsNumber})}/>
                                </FormGroup>
                            </Col>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Ελάχιστη Παλαιότητα (μήνες)</Label>
                                    <Input type="number" value={offerPackage.assessment4minAge}
                                           onChange={e => setOfferPackage({...offerPackage, assessment4minAge: e.target.valueAsNumber})}/>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Αξιολόγηση</Label>
                                    <Input type={"select"} value={offerPackage.assessment5}
                                           onChange={e =>
                                               setOfferPackage({...offerPackage, assessment5: e.target.value})}>
                                        <option value="">Επιλέξτε Αξιολόγηση</option>
                                        {
                                            getAssessments().map(a => <option key={a} value={a}>{a}</option>)
                                        }
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Ποσότητα (τόνοι)</Label>
                                    <Input type={"number"} value={offerPackage.assessment5Qty}
                                    onChange={(e) => setOfferPackage({...offerPackage, assessment5Qty: e.target.valueAsNumber})}/>
                                </FormGroup>
                            </Col>
                            <Col md={"4"}>
                                <FormGroup>
                                    <Label>Ελάχιστη Παλαιότητα (μήνες)</Label>
                                    <Input type="number" value={offerPackage.assessment5minAge}
                                           onChange={e => setOfferPackage({...offerPackage, assessment5minAge: e.target.valueAsNumber})}/>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Button color={'info'} size={'sm'} type={'submit'} block>Αποθήκευση</Button>
                    </Form>
                </ModalBody>
            </Modal>
        </>

};

export default withTranslation(OfferPackages);